import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'
import { Tooltip } from 'antd'
import { useAppSelector } from '../../../../app/store/hooks/Redux'
import { selectTrademarkInfringementsFilters } from '../../model/trademarkInfringementsSlice'
import { ComplaintStatusBadge } from '../../ui/ComplaintStatusBadge'
import { COMPLAINT_STATUSES } from '../../model/types/ComplaintStatus.type'
import { useGetTmInfringementsDomainSummaryQuery } from '../../../../app/api'

export const TrademarkInfringementsDomainSummary = () => {
  const { project, country, site } = useAppSelector(selectTrademarkInfringementsFilters)

  const { data } = useGetTmInfringementsDomainSummaryQuery(
    {
      projectId: project as unknown as number,
      domain: site as string,
      countryId: (country || undefined) as unknown as number[],
    },
    { skip: !project || !site },
  )

  const items = data?.data ?? []

  const groups = useMemo(
    () =>
      COMPLAINT_STATUSES.map((status) => ({
        status,
        countries: items.filter(({ complaint_status }) => complaint_status === status),
      })).filter(({ countries }) => countries.length),
    [items],
  )

  if (!site || !groups.length) return null

  return (
    <div className={'flex flex-col gap-[16px] rounded-[12px] bg-focus/[0.05] py-[12px] px-[16px]'}>
      <p className={'text-[16px] text-focus-500 opacity-80'}>
        <Trans
          i18nKey='pages.trademarkInfringements.domainPerCountryCases'
          values={{ domain: site }}
        >
          <span className={'text-focus'} />
        </Trans>
      </p>
      <div className={'flex items-center gap-[24px]'}>
        {groups.map(({ status, countries: [first, ...rest] }, index) => (
          <React.Fragment key={status}>
            {!!index && <span className={'h-[16px] w-[1px] shrink-0 bg-focus-300'} />}
            <div className={'flex items-center gap-[8px]'}>
              <ComplaintStatusBadge status={status} />
              <span
                className={`fi fis fi-${first.country_code} block !h-[20px] !w-[20px] rounded-full`}
              />
              <p className={'text-[16px] text-focus-500'}>{first.country}</p>
              {!!rest.length && (
                <Tooltip title={rest.map(({ country }) => country).join(', ')}>
                  <span
                    className={
                      'cursor-default rounded-[4px] bg-focus-50 p-[4px] text-[13px] leading-[13px] text-aqua-300'
                    }
                  >
                    +{rest.length}
                  </span>
                </Tooltip>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}
